// export const colors = {
// 	z0:  "hsla(0, 0%, 4%, 1)",
// 	z1: "hsla(0, 0%, 8%, 1)",
// 	z2: "rgba(34, 34, 34, 1)",
// 	z3: "rgba(46, 46, 46, 1)",
// 	z4: "rgba(58, 58, 58, 1)",
// 	z5: "rgba(70, 70, 70, 1)",
// 	z6: "rgba(80, 80, 80, 1)",

// 	accent:   "rgba(237, 0, 235, 1)",
// 	accent08: "rgba(237, 0, 235, .08)",
// 	accent20: "rgba(237, 0, 235, .2)",
// 	accent50: "rgba(237, 0, 235, .5)",
// 	accent75: "rgba(237, 0, 235, .75)",

// 	white: "rgba(255, 255, 255, 1)",
// 	white60: "rgba(255, 255, 255, 0.6)",
// 	white40: "rgba(255, 255, 255, 0.4)",
// 	white25: "rgba(255, 255, 255, 0.25)",
// 	white16: "rgba(255, 255, 255, 0.16)",
// 	white12: "rgba(255, 255, 255, 0.12)",
// 	white08: "rgba(255, 255, 255, 0.08)",
// 	white04: "rgba(255, 255, 255, 0.04)",
// 	white03: "rgba(255, 255, 255, 0.03)",
// 	white02: "rgba(255, 255, 255, 0.02)",

// 	text: "rgba(166, 166, 166, 1)",

// 	pageBackground: "hsla(0, 0%, 8%, 1)",
// 	tileBackground: "hsla(0, 0%, 8%, 1)",
// 	diagramBackground: "hsla(0, 0%, 10%, 1)",
// 	nullTileBackground: "hsla(0, 0%, 12%, 1)",
// 	pageThumbnailSelectedBackground: "hsla(0, 0%, 17%)",
// 	selectionRectBackground: "hsla(301, 100%, 46%, 0.05)",

// 	green: "rgba(48, 209, 88, 1)",
// 	addTile: "rgba(237, 0, 235, 1)",

// 	annotations: {
// 		yellow: { background: "rgba(255, 229, 0, 1)", foreground: "rgba(0, 0, 0, 0.9)" },
// 		cyan: { background: "rgba(117, 251, 220, 1)", foreground: "rgba(0, 0, 0, 0.9)" },
// 		magenta: { background: "rgba(237, 0, 235, 1)", foreground: "rgba(255, 255, 255, 0.9)" },
// 		white: { background: "rgba(255, 255, 255, 1)", foreground: "rgba(0, 0, 0, 0.9)" },
// 	},

// 	nullTileBackgrounds: {
// 		giphy: "rgba(38, 32, 47, 1)",
// 		figma: "rgba(29, 43, 36, 1)",
// 		airtable: "rgba(44, 29, 30, 1)",
// 		twitter: "rgba(21, 27, 31, 1)",
// 	}

// };

/*
COLORS
*/
export const colors = {};

/*
Dark
*/
colors.dark = {};

// Opaque colors
colors.dark.opaque = {};
colors.dark.opaque.z0 = "hsla(0, 0%, 0%, 1)";
colors.dark.opaque.z1 = "hsla(0, 0%, 8%, 1)";
colors.dark.opaque.z2 = "hsla(0, 0%, 12%, 1)";
colors.dark.opaque.z3 = "hsla(0, 0%, 16%, 1)";
colors.dark.opaque.z4 = "hsla(0, 0%, 20%, 1)";
colors.dark.opaque.z5 = "hsla(0, 0%, 24%, 1)";
colors.dark.opaque.z6 = "hsla(0, 0%, 65%, 1)";

// Transparent colors
colors.dark.transparent = {};
colors.dark.transparent.t0 = "hsla(0, 0%, 100%, .00)";
colors.dark.transparent.t1 = "hsla(0, 0%, 100%, .04)";
colors.dark.transparent.t2 = "hsla(0, 0%, 100%, .08)";
colors.dark.transparent.t3 = "hsla(0, 0%, 100%, .12)";
colors.dark.transparent.t4 = "hsla(0, 0%, 100%, .16)";
colors.dark.transparent.t5 = "hsla(0, 0%, 100%, .20)";
colors.dark.transparent.t6 = "hsla(0, 0%, 100%, .25)";
colors.dark.transparent.t7 = "hsla(0, 0%, 100%, .40)";
colors.dark.transparent.t8 = "hsla(0, 0%, 100%, .60)";
colors.dark.transparent.t9 = "hsla(0, 0%, 100%, 1.0)";

// Shadows
colors.dark.shadows = {};
colors.dark.shadows.small = "0px 2px 8px hsla(0, 0%, 0%, 0.15)";
colors.dark.shadows.medium = "0px 6px 16px hsla(0, 0%, 0%, 0.25), 0px 0px 0px 1px hsla(0, 0%, 100%, 0.08)";
colors.dark.shadows.large = "0px 8px 24px hsla(0, 0%, 0%, 0.25)";

// Media controls
colors.dark.mediaControls = {};
colors.dark.mediaControls.background = "hsla(0, 0%, 25%, 0.6)";
colors.dark.mediaControls.blur = "blur(100px)";

/*
Light
*/
colors.light = {};

// Opaque colors
colors.light.opaque = {};
colors.light.opaque.z0 = "hsla(0, 0%, 100%, 1)";
colors.light.opaque.z1 = "hsla(0, 0%, 96%, 1)";
colors.light.opaque.z2 = "hsla(0, 0%, 92%, 1)";
colors.light.opaque.z3 = "hsla(0, 0%, 86%, 1)";
colors.light.opaque.z4 = "hsla(0, 0%, 64%, 1)";
colors.light.opaque.z5 = "hsla(0, 0%, 40%, 1)";
colors.light.opaque.z6 = "hsla(0, 0%, 16%, 1)";

// Transparent colors
colors.light.transparent = {};
colors.light.transparent.t0 = "hsla(0, 0%, 0%, .00)";
colors.light.transparent.t1 = "hsla(0, 0%, 0%, .04)";
colors.light.transparent.t2 = "hsla(0, 0%, 0%, .06)";
colors.light.transparent.t3 = "hsla(0, 0%, 0%, .08)";
colors.light.transparent.t4 = "hsla(0, 0%, 0%, .12)";
colors.light.transparent.t5 = "hsla(0, 0%, 0%, .16)";
colors.light.transparent.t6 = "hsla(0, 0%, 0%, .25)";
colors.light.transparent.t7 = "hsla(0, 0%, 0%, .40)";
colors.light.transparent.t8 = "hsla(0, 0%, 0%, .60)";
colors.light.transparent.t9 = "hsla(0, 0%, 0%, .85)";

// Shadows
colors.light.shadows = {};
colors.light.shadows.small = "0px 2px 8px hsla(0, 0%, 0%, 0.06), 0px 0px 0px 1px hsla(0, 0%, 0%, 0.04)";
colors.light.shadows.medium = "0px 6px 16px hsla(0, 0%, 0%, 0.06), 0px 0px 0px 1px hsla(0, 0%, 0%, 0.04)";
colors.light.shadows.large = "0px 8px 24px hsla(0, 0%, 0%, 0.06), 0px 0px 0px 1px hsla(0, 0%, 0%, 0.04)";
colors.light.shadows.overhead =
	"0px 0px 0px hsla(0, 0%, 0%, 0.04), 0px 0px 2px hsla(0, 0%, 0%, 0.12), 0px 0px 0px 1px hsla(0, 0%, 0%, 0.08)";
colors.light.shadows.stroke = "0px 4px 12px hsla(0, 0%, 0%, 0.04), 0px 0px 0px 1px hsla(0, 0%, 0%, 0.04)";

// Media controls
colors.light.mediaControls = {};
colors.light.mediaControls.background = "hsla(0, 0%, 0%, 0.06)";
colors.light.mediaControls.blur = "blur(50px)";



/*
Accent
*/
colors.accent = "hsla(301, 100%, 46%, 1)";
colors.accentHover = "hsla(301, 100%, 60%, 1)";
colors.accent60 = "hsla(301, 100%, 46%, 0.6)";
colors.accent40 = "hsla(301, 100%, 46%, 0.4)";
colors.accent35 = "hsla(301, 42%, 25%, 1)";
//colors.accent30 = "hsla(301, 43%, 21%, 1)";
colors.accent30 = "hsla(301, 100%, 46%, 0.25)";
colors.accent25 = "hsla(302, 44%, 17%, 1)";
colors.accent20 = "hsla(301, 43%, 14%, 1)";
colors.accent15 = "hsla(301, 100%, 46%, 0.15)";
colors.accent10 = "hsla(301, 100%, 46%, 0.1)";



/*
Core
*/
colors.core = {};
colors.core.red = "hsla(3, 100%, 62%, 1)";
colors.core.redHover = "hsla(3, 100%, 66%, 1)";
colors.core.yellow = "hsla(54, 100%, 50%, 1)";
colors.core.cyan = "hsla(166, 94%, 72%, 1)";


/*
Warning
*/
colors.dark.warning = "hsla(11, 60%, 54%, 1)";
colors.light.warning = "hsla(27, 98%, 45%, 1)";